import * as React from "react";
import { Doc } from "@repo/convex/convex/_generated/dataModel";

interface Props {
  profileDoc: Doc<"userProfiles">;
}

export const TokenUsageTable: React.FC<Props> = ({ profileDoc }) => {
  const promptTokensUsed = profileDoc.promptTokensUsed ?? 0;
  const completionTokensUsed = profileDoc.completionTokensUsed ?? 0;
  const totalTokensUsed = profileDoc.totalTokensUsed ?? 0;
  // OpenRouter reports the real cost of each call. It only started being recorded when we moved
  // off OpenAI, so older profile updates aren't in this number.
  const costUsed = profileDoc.costUsed ?? 0;

  return (
    <dl className="settings-usage">
      <div>
        <dt>Prompt tokens</dt>
        <dd>{promptTokensUsed.toLocaleString()}</dd>
      </div>
      <div>
        <dt>Completion tokens</dt>
        <dd>{completionTokensUsed.toLocaleString()}</dd>
      </div>
      <div>
        <dt>Total tokens</dt>
        <dd>{totalTokensUsed.toLocaleString()}</dd>
      </div>
      <div>
        <dt>Cost since OpenRouter</dt>
        <dd>${costUsed.toFixed(4)}</dd>
      </div>
    </dl>
  );
};
